/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: GPT-5 Codex
 🏢 Company: Ring2All LLC
 📄 File: constants/hangupCauses.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    Hangup Cause values for CDR Filters.
────────────────────────────────────────────────────────────────*/

/**
 * List of Hangup Cause values
 */
export const HANGUP_CAUSE_VALUES = [
  'UNALLOCATED_NUMBER',
  'NO_ROUTE_TRANSIT_NET',
  'NO_ROUTE_DESTINATION',
  'CHANNEL_UNACCEPTABLE',
  'CALL_AWARDED_DELIVERED',
  'NORMAL_CLEARING',
  'USER_BUSY',
  'NO_USER_RESPONSE',
  'NO_ANSWER',
  'SUBSCRIBER_ABSENT',
  'CALL_REJECTED',
  'NUMBER_CHANGED',
  'REDIRECTION_TO_NEW_DESTINATION',
  'DESTINATION_OUT_OF_ORDER',
  'INVALID_NUMBER_FORMAT',
  'FACILITY_REJECTED',
  'RESPONSE_TO_STATUS_ENQUIRY',
  'NORMAL_UNSPECIFIED',
  'NORMAL_CIRCUIT_CONGESTION',
  'NETWORK_OUT_OF_ORDER',
  'NORMAL_TEMPORARY_FAILURE',
  'SWITCH_CONGESTION',
  'ACCESS_INFO_DISCARDED',
  'REQUESTED_CHAN_UNAVAIL',
  'PRE_EMPTION',
  'FACILITY_NOT_IMPLEMENTED',
  'RESTRICTED_BEARERCAPABILITY_NOTAVAIL',
  'SERVICE_UNAVAILABLE',
  'BEARERCAPABILITY_NOTIMPL',
  'CHAN_NOT_IMPLEMENTED',
  'INVALID_CALL_REFERENCE',
  'INCOMPATIBLE_DESTINATION',
  'INVALID_MSG_UNSPECIFIED',
  'MANDATORY_IE_MISSING',
  'MESSAGE_TYPE_NONEXIST',
  'WRONG_MESSAGE',
  'IE_FIELD_MISSING',
  'INVALID_GATEWAY',
  'ORIGINATOR_CANCEL',
  'CRASH',
  'SYSTEM_SHUTDOWN',
  'LOSE_RACE',
  'ALLOTTED_TIMEOUT',
  'MANAGER_REQUEST',
  'BLIND_TRANSFER',
  'ATTENDED_TRANSFER',
  'PICKED_OFF',
  'USER_NOT_REGISTERED',
  'PROGRESS_TIMEOUT',
  'MEDIA_TIMEOUT',
  'RTP_TIMEOUT',
  'SESSION_TIMEOUT',
  'GATEWAY_DOWN',
  'DIGIT_TIMEOUT',
  'DESTINATION_NOT_OBTAINABLE',
  'MEDIA_READ_ERROR',
  'MEDIA_WRITE_ERROR',
  'READ_FRAME_ERROR',
  'WRITE_FRAME_ERROR',
  'OUTGOING_CALL_BARRED',
  'INCOMING_CALL_BARRED',
  'BEARERCAPABILITY_NOTAUTH',
  'BEARERCAPABILITY_NOTAVAIL',
  'CALL_BLOCKED',
  'UNAUTHENTICATED',
  'NO_AGENT',
  'OVERLAY_ERROR',
  'MISDELETED',
  'RATE_LIMIT',
] as const;

export type HangupCauseValue = typeof HANGUP_CAUSE_VALUES[number];

